import { MdSearch } from 'react-icons/md'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 56px 160px;
  min-width: 0;
  ${({ theme }) => theme.media.tablet} {
    padding: 56px 32px;
    flex-direction: column;
  }
  ${({ theme }) => theme.media.phone} {
    padding: 10px 16px 56px;
    flex-direction: column;
  }
`

export const Header = styled.div`
  display: flex;
  margin: 40px 0 48px;
  ${({ theme }) => theme.font.h1}
  line-height: 82px;
  color: ${({ theme }) => theme.colors.black};
  ${({ theme }) => theme.utils.ellipsis}
  span {
    color: ${({ theme }) => theme.colors.grey};
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  max-width: 1440px;
`

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 88px;
  @media screen and (max-width: 1400px) {
    margin-right: 48px;
  }
  ${({ theme }) => theme.media.phone} {
    margin: 0;
  }
`

export const TabsContent = styled.div`
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

export const EmptyContainer = styled.div`
  color: ${({ theme }) => theme.colors.grey};
  ${({ theme }) => theme.font.h2}
  margin: 0 auto;
  margin-top: 50px;
  width: 100%;
  max-width: 1440px;
`

export const SearchIcon = styled(MdSearch)`
  font-size: 24px;
  min-width: 24px;
  margin-right: 10px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`
